

















































































































































































































































































import {
  SfLoader,
  SfNotification,
  SfSidebar,
  SfHeading,
  SfButton,
  SfProperty,
  SfPrice,
  SfCollectedProduct,
  SfQuantitySelector,
  SfBadge,
  SfImage,
} from '@storefront-ui/vue';
import {
  computed,
  defineComponent,
  useRouter,
  useContext,
} from '@nuxtjs/composition-api';
import {
  useUiState,
} from '@wemade-vsf/composables';
import CouponCode from 'components/checkout/Cart/CouponCode.vue';
import { useCart } from '@wemade-vsf/customer';
import { useCartView } from '@wemade-vsf/checkout';
import { useCustomerPricing } from '@wemade-vsf/catalog/lib/runtime/product/composables/useCustomerPricing';
import CartItemAdditionalInformation from 'components/checkout/Cart/CartItemAdditionalInformation.vue';

export default defineComponent({
  name: 'CartSidebar',
  components: {
    SfLoader,
    SfNotification,
    SfSidebar,
    SfButton,
    SfHeading,
    SfProperty,
    SfPrice,
    SfCollectedProduct,
    SfQuantitySelector,
    SfBadge,
    CouponCode,
    SfImage,
    CartItemAdditionalInformation
  },
  setup() {
    const cartView = useCartView();
    const { isCartSidebarOpen, toggleCartSidebar } = useUiState();
    const { displayPricesIncludingTax: arePricesIncludingTax } = useCustomerPricing();
    const { cart } = useCart();
    const router = useRouter();
    const { app } = useContext();

    const goToCart = async () => {
      await router.push(app.localeRoute({ name: 'cart' }));
    };

    const calculatedSubtotal = computed(() => {
      const totals = cartView.totals.value
      const subtotal = arePricesIncludingTax.value ? totals?.subtotal ?? 0 : totals?.subtotal_excl_tax ?? 0
      if (cartView.discount.value < 0) {
        return Number(subtotal) + Number(cartView.discount.value)
      }
      return Number(subtotal)
    })

    const discountLabel = computed(() => {
      if (cartView.discount.value < 0) {
        if (cart.value?.prices?.discounts?.length === 1 && cart.value?.applied_coupons?.length === 1) {
          return app.i18n.t('Discount') + ' (' + cart.value.applied_coupons[0].code + ')'
        }
        return app.i18n.t('Discount');
      }
      return '';
    })

    return {
      ...cartView,
      arePricesIncludingTax,
      calculatedSubtotal,
      isCartSidebarOpen,
      discountLabel,
      toggleCartSidebar,
      goToCart,
    };
  },
});
